"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousPricingZone = void 0;
const typebox_1 = require("@sinclair/typebox");
const pricing_zone_1 = require("./pricing-zone");
exports.AnonymousPricingZone = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(pricing_zone_1.PricingZone, [
        'id',
        'materials',
        'prohibitedItems',
        'state',
        'tripCharge',
        'days',
        'rentalPeriod',
        'rentExtensionFee',
        'pricingCalculationVersion',
        'maxRentalDaysAllowed',
        'prePaidRentalDaysDiscountRate',
        'allowForPrePaidRentalDays',
        'onlineCheckoutPageGuarantee',
        'actualTaxRate',
        'type',
        'fees',
        // Changes
        'customerID', // What are we doing with this? -- is it staying in PricingZone or no?
    ]),
    typebox_1.Type.Object({
        serviceAreas: typebox_1.Type.Array(typebox_1.Type.Pick(pricing_zone_1.ServiceArea, ['id', 'serviceArea', 'areaName', 'taxJurisdiction'])),
    }),
]);
//# sourceMappingURL=anonymous-pricing-zone.js.map